export default __webpack_public_path__ + "static/media/sidebar-1.d4b3c417.jpg";